import { encode } from 'blurhash';

/**
 * Encodes from a canvas already in memory rather than refetching the uploaded image over the
 * network. The URL-based version needed `crossOrigin` on the element and raced the object's
 * write visibility; neither problem exists here.
 */
export const encodeCanvasToBlurhash = (canvas: HTMLCanvasElement) => {
  const imageData = canvas.getContext('2d')!.getImageData(0, 0, canvas.width, canvas.height);
  return encode(imageData.data, imageData.width, imageData.height, 4, 4);
};
